import { AfpantOutboxFile } from "@/components/AfpantOutboxFile/AfpantOutboxFile";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/")({
  loader: async ({ params }) => {
    const { orgNumber, outboxFileId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["outbox-file"][":outboxFileId"].$get({
      param: {
        orgNumber,
        outboxFileId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch outbox file");
    }

    return {
      file: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Utboksfil | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { file } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Utboksfil</DocumentTitle>

      <AfpantOutboxFile file={file} />
    </>
  );
}
